module.exports = __webpack_public_path__ + "img/75.53bfa38c.jpg";